var _path, _path2, _path3, _path4, _path5, _path6, _circle, _ellipse, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _polygon, _path55, _polygon2, _path56, _path57, _path58, _circle2, _circle3, _path59, _circle4, _path60, _path61, _path62, _path63, _polygon3, _path64, _polygon4, _path65, _path66, _circle5, _path67, _path68, _path69, _path70, _polygon5, _polygon6, _polygon7, _polygon8, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _polygon9, _path86, _polygon0, _path87, _path88, _path89, _circle6, _path90, _path91, _path92, _path93, _polygon1, _polygon10, _path94, _path95, _path96, _polygon11, _polygon12, _polygon13, _polygon14, _path97, _path98, _rect, _rect2, _path99, _circle7, _polygon15, _path100, _polygon16, _path101, _path102, _path103, _path104, _rect3, _rect4, _path105, _path106, _path107, _path108, _rect5, _rect6, _polygon17, _polygon18, _rect7, _rect8, _path109, _path110, _path111, _path112, _polygon19, _path113, _polygon20, _path114, _path115, _circle8, _path116, _path117, _path118, _circle9, _path119, _path120, _path121, _path122, _path123, _path124, _path125;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWellcome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1047.79529,
    height: 450.30891,
    viewBox: "0 0 1047.79529 450.30891",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.42222,619.66535a17.16536,17.16536,0,0,1,34.33071,0",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.58758,619.66535a.464.464,0,0,1-.46393-.46392v-9.04661a.46393.46393,0,1,1,.92786,0v9.04661A.464.464,0,0,1,122.58758,619.66535Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.58735,616.55672a.4618.4618,0,0,1-.302-.11191l-5.56709-4.77814a.46392.46392,0,1,1,.60432-.704l5.56715,4.77814a.46394.46394,0,0,1-.30242.816Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.31007,619.66535a17.16536,17.16536,0,0,1,34.33071,0",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M175.47543,619.66535a.46394.46394,0,0,1-.46393-.46392v-9.04661a.46393.46393,0,0,1,.92786,0v9.04661A.464.464,0,0,1,175.47543,619.66535Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M175.4752,616.55672a.4618.4618,0,0,1-.302-.11191l-5.56714-4.77814a.46394.46394,0,1,1,.60437-.704l5.56714,4.77814a.46393.46393,0,0,1-.30241.816Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 784.79529,
    cy: 34.30891,
    r: 33,
    fill: "#f2f2f2"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.79529,
    cy: 425.30891,
    rx: 30,
    ry: 7,
    fill: "#f2f2f2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M169.5834,362.15323c7.86794-24.56856,27.0799-43.62236,49.86392-54.95493,27.03309-13.446,58.097-14.96842,87.44924-9.73524,31.68593,5.64926,61.30021,18.67245,89.96562,32.88447,28.11677,13.94,55.78,28.65962,85.02063,40.1796A550.37542,550.37542,0,0,0,664.82936,408.4226c56.43083,1.88251,116.76658-4.30052,165.08463-36.018,44.27252-29.06184,72.44421-77.00553,87.11694-126.98162q2.81766-9.59714,5.00971-19.35932c.42636-1.87992-2.46532-2.68258-2.89284-.79752C907.312,277.45383,882.07353,329.03314,838.95,362.3001,792.3092,398.28036,731.09593,406.598,673.8132,405.6462A547.717,547.717,0,0,1,488.48144,369.882c-29.99274-11.41833-58.29583-26.24534-86.95951-40.55968-28.03408-13.99992-56.85571-27.10508-87.68288-33.56193-28.14937-5.896-58.28757-6.25529-85.42785,4.2364-22.34794,8.6391-42.72459,24.03773-54.64936,45.10247a86.49412,86.49412,0,0,0-7.07128,16.25645c-.59019,1.843,2.30536,2.632,2.89284.79752Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M597.88583,591.87008a1,1,0,0,0,0-2h-9.5v-4h9.5a1,1,0,0,0,0-2h-81a1,1,0,0,0,0,2h9.5v4h-9.5a1,1,0,0,0,0,2h9.5v4h-9.5a1,1,0,0,0,0,2h9.5v4h-8.5a2,2,0,0,0,0,4h8.0918a1.49061,1.49061,0,0,0-.0918.5v14a1.5,1.5,0,0,0,3,0v-14a1.4906,1.4906,0,0,0-.09179-.5h57.18359a1.49061,1.49061,0,0,0-.0918.5v14a1.5,1.5,0,0,0,3,0v-14a1.4906,1.4906,0,0,0-.09179-.5h8.09179a2,2,0,0,0,0-4h-8.5v-4h9.5a1,1,0,0,0,0-2h-9.5v-4Zm-69.5-6h58v4h-58Zm58,16h-58v-4h58Zm0-6h-58v-4h58Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M292.89767,549.89841c0-17.66118-14.3269-59.57029-32-59.57029s-32,41.90911-32,59.57029a32,32,0,0,0,64.00007,0Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M284.89767,549.89841c0-17.66118-14.3269-59.57029-32-59.57029s-32,41.90911-32,59.57029a32,32,0,0,0,64.00007,0Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M253.89764,621.44892a1.00005,1.00005,0,0,1-1-1V531.3083a1,1,0,0,1,2,0v89.14062A1,1,0,0,1,253.89764,621.44892Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M253.89764,545.92158a1,1,0,0,1-.707-1.707l13.07764-13.07813a.99989.99989,0,0,1,1.41406,1.41406l-13.07763,13.07813A.99638.99638,0,0,1,253.89764,545.92158Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M621.89764,621.44892a1.00005,1.00005,0,0,1-1-1V531.3083a1,1,0,0,1,2,0v89.14062A1,1,0,0,1,621.89764,621.44892Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M728.89767,549.89841c0-17.66118-14.3269-59.57029-32-59.57029s-32,41.90911-32,59.57029a32,32,0,0,0,64.00007,0Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M720.89767,549.89841c0-17.66118-14.3269-59.57029-32-59.57029s-32,41.90911-32,59.57029a32,32,0,0,0,64.00007,0Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M689.89764,621.44892a1.00005,1.00005,0,0,1-1-1V531.3083a1,1,0,0,1,2,0v89.14062A1,1,0,0,1,689.89764,621.44892Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M689.89764,545.92158a1,1,0,0,1-.707-1.707l13.07764-13.07813a.99989.99989,0,0,1,1.41406,1.41406l-13.07763,13.07813A.99638.99638,0,0,1,689.89764,545.92158Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M359.89764,276h-16a4.505,4.505,0,0,1-4.5-4.5v-37a4.505,4.505,0,0,1,4.5-4.5h16a4.505,4.505,0,0,1,4.5,4.5v37A4.505,4.505,0,0,1,359.89764,276Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M422.89764,621h-82a8.50958,8.50958,0,0,1-8.5-8.5v-331a8.50958,8.50958,0,0,1,8.5-8.5h82a8.5095,8.5095,0,0,1,8.5,8.5v331A8.5095,8.5095,0,0,1,422.89764,621Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M373.89764,621h-82a8.50958,8.50958,0,0,1-8.5-8.5v-331a8.50958,8.50958,0,0,1,8.5-8.5h82a8.50958,8.50958,0,0,1,8.5,8.5v331A8.50958,8.50958,0,0,1,373.89764,621Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M344.89764,276h-16a4.505,4.505,0,0,1-4.5-4.5v-37a4.505,4.505,0,0,1,4.5-4.5h16a4.505,4.505,0,0,1,4.5,4.5v37A4.505,4.505,0,0,1,344.89764,276Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M323.89764,348h-19a2.50286,2.50286,0,0,1-2.5-2.5v-29a2.50286,2.50286,0,0,1,2.5-2.5h19a2.50286,2.50286,0,0,1,2.5,2.5v29A2.50286,2.50286,0,0,1,323.89764,348Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M360.89764,348h-19a2.50286,2.50286,0,0,1-2.5-2.5v-29a2.50286,2.50286,0,0,1,2.5-2.5h19a2.50286,2.50286,0,0,1,2.5,2.5v29A2.50286,2.50286,0,0,1,360.89764,348Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M323.89764,401h-19a2.50286,2.50286,0,0,1-2.5-2.5v-29a2.50286,2.50286,0,0,1,2.5-2.5h19a2.50286,2.50286,0,0,1,2.5,2.5v29A2.50286,2.50286,0,0,1,323.89764,401Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M360.89764,401h-19a2.50286,2.50286,0,0,1-2.5-2.5v-29a2.50286,2.50286,0,0,1,2.5-2.5h19a2.50286,2.50286,0,0,1,2.5,2.5v29A2.50286,2.50286,0,0,1,360.89764,401Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M323.89764,454h-19a2.50286,2.50286,0,0,1-2.5-2.5v-29a2.50286,2.50286,0,0,1,2.5-2.5h19a2.50286,2.50286,0,0,1,2.5,2.5v29A2.50286,2.50286,0,0,1,323.89764,454Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M360.89764,454h-19a2.50286,2.50286,0,0,1-2.5-2.5v-29a2.50286,2.50286,0,0,1,2.5-2.5h19a2.50286,2.50286,0,0,1,2.5,2.5v29A2.50286,2.50286,0,0,1,360.89764,454Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M323.89764,507h-19a2.50286,2.50286,0,0,1-2.5-2.5v-29a2.50286,2.50286,0,0,1,2.5-2.5h19a2.50286,2.50286,0,0,1,2.5,2.5v29A2.50286,2.50286,0,0,1,323.89764,507Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M360.89764,507h-19a2.50286,2.50286,0,0,1-2.5-2.5v-29a2.50286,2.50286,0,0,1,2.5-2.5h19a2.50286,2.50286,0,0,1,2.5,2.5v29A2.50286,2.50286,0,0,1,360.89764,507Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M323.89764,560h-19a2.50286,2.50286,0,0,1-2.5-2.5v-29a2.50286,2.50286,0,0,1,2.5-2.5h19a2.50286,2.50286,0,0,1,2.5,2.5v29A2.50286,2.50286,0,0,1,323.89764,560Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M360.89764,560h-19a2.50286,2.50286,0,0,1-2.5-2.5v-29a2.50286,2.50286,0,0,1,2.5-2.5h19a2.50286,2.50286,0,0,1,2.5,2.5v29A2.50286,2.50286,0,0,1,360.89764,560Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M772.89764,451h-16a4.50508,4.50508,0,0,1-4.5-4.5v-21a4.50508,4.50508,0,0,1,4.5-4.5h16a4.50507,4.50507,0,0,1,4.5,4.5v21A4.50507,4.50507,0,0,1,772.89764,451Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M907.89764,622h-82a8.50951,8.50951,0,0,1-8.5-8.5v-159a8.50951,8.50951,0,0,1,8.5-8.5h82a8.5095,8.5095,0,0,1,8.5,8.5v159A8.5095,8.5095,0,0,1,907.89764,622Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M858.89764,622h-142a8.50951,8.50951,0,0,1-8.5-8.5v-159a8.50951,8.50951,0,0,1,8.5-8.5h142a8.5095,8.5095,0,0,1,8.5,8.5v159A8.5095,8.5095,0,0,1,858.89764,622Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M757.89764,451h-16a4.50508,4.50508,0,0,1-4.5-4.5v-21a4.50508,4.50508,0,0,1,4.5-4.5h16a4.50507,4.50507,0,0,1,4.5,4.5v21A4.50507,4.50507,0,0,1,757.89764,451Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M778.89764,524.5h-19a2.50295,2.50295,0,0,1-2.5-2.5V493a2.50295,2.50295,0,0,1,2.5-2.5h19a2.50294,2.50294,0,0,1,2.5,2.5v29A2.50294,2.50294,0,0,1,778.89764,524.5Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M815.89764,524.5h-19a2.50295,2.50295,0,0,1-2.5-2.5V493a2.50295,2.50295,0,0,1,2.5-2.5h19a2.50294,2.50294,0,0,1,2.5,2.5v29A2.50294,2.50294,0,0,1,815.89764,524.5Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M778.89764,577.5h-19a2.50295,2.50295,0,0,1-2.5-2.5V546a2.50295,2.50295,0,0,1,2.5-2.5h19a2.50294,2.50294,0,0,1,2.5,2.5v29A2.50294,2.50294,0,0,1,778.89764,577.5Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M815.89764,577.5h-19a2.50295,2.50295,0,0,1-2.5-2.5V546a2.50295,2.50295,0,0,1,2.5-2.5h19a2.50294,2.50294,0,0,1,2.5,2.5v29A2.50294,2.50294,0,0,1,815.89764,577.5Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1122.89764,622.5H77.10236a1,1,0,1,1,0-2H1122.89764a1,1,0,0,1,0,2Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M438.89764,657.5h-93a1,1,0,0,1,0-2h93a1,1,0,1,1,0,2Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M669.89764,657.5h-93a1,1,0,0,1,0-2h93a1,1,0,1,1,0,2Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M900.89764,657.5h-93a1,1,0,0,1,0-2h93a1,1,0,1,1,0,2Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M491.89767,549.89841c0-17.66118-14.3269-59.57029-32-59.57029s-32,41.90911-32,59.57029a32,32,0,0,0,64.00007,0Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M483.89767,549.89841c0-17.66118-14.3269-59.57029-32-59.57029s-32,41.90911-32,59.57029a32,32,0,0,0,64.00007,0Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M452.89764,621.44892a1.00005,1.00005,0,0,1-1-1V531.3083a1,1,0,0,1,2,0v89.14062A1,1,0,0,1,452.89764,621.44892Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M452.89764,545.92158a1,1,0,0,1-.707-1.707l13.07764-13.07813a.99989.99989,0,0,1,1.41406,1.41406l-13.07763,13.07813A.99638.99638,0,0,1,452.89764,545.92158Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M1002.89767,549.89841c0-17.66118-14.3269-59.57029-32-59.57029s-32,41.90911-32,59.57029a32,32,0,0,0,64.00007,0Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M994.89767,549.89841c0-17.66118-14.3269-59.57029-32-59.57029s-32,41.90911-32,59.57029a32,32,0,0,0,64.00007,0Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M963.89764,621.44892a1.00005,1.00005,0,0,1-1-1V531.3083a1,1,0,0,1,2,0v89.14062A1,1,0,0,1,963.89764,621.44892Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M963.89764,545.92158a1,1,0,0,1-.707-1.707l13.07764-13.07813a.99989.99989,0,0,1,1.41406,1.41406l-13.07763,13.07813A.99638.99638,0,0,1,963.89764,545.92158Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M632.89746,561h-22a2.50231,2.50231,0,0,1-2.5-2.5v-22a2.50231,2.50231,0,0,1,2.5-2.5h22a2.50231,2.50231,0,0,1,2.5,2.5v22A2.50231,2.50231,0,0,1,632.89746,561Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#3f3d56"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M846.46333,571.71339a1.69978,1.69978,0,0,1,1.11111,2.35775l4.348,4.19318-3.063.68665-3.65937-4.08718a1.709,1.709,0,0,1,1.26319-3.1504Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ffb8b8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M852.57772,582.744l-5.36389-5.03209a.7607.7607,0,0,1-.02082-1.08921l1.09531-1.10926a.76178.76178,0,0,1,1.00311-.06992l4.495,3.43528,2.80441-6.80135a2.12261,2.12261,0,0,1,2.89645-1.09685h0a2.10957,2.10957,0,0,1,1.16138,2.24944c-.509,3.09369-3.59187,7.1835-5.3843,9.34606a1.85312,1.85312,0,0,1-2.066.55439A1.84822,1.84822,0,0,1,852.57772,582.744Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M849.56783,577.86246l-3.94907-5.72789a.33844.33844,0,0,1,.08646-.47021l.15863-.10937a.33807.33807,0,0,1,.47022.0865l3.949,5.72789a.338.338,0,0,1-.08642.47021l-.15864.10937a.33838.33838,0,0,1-.47021-.0865Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M848.46384,577.90505l-3.27741-4.75377a.93075.93075,0,0,1,.2377-1.29313l.33395-.23019,4.33283,6.28452-.33391.23028h0a.93041.93041,0,0,1-1.29312-.23771Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#3f3d56"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "772.758 394.744 770.699 394.507 770.972 386.492 773.674 386.804 772.758 394.744",
    fill: "#ffb8b8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M849.155,620.9917l-6.63808-.76612.00969-.084a2.60081,2.60081,0,0,1,2.88185-2.28562l.00016,0,4.0543.46793Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "796.697 393.222 794.717 393.834 791.416 386.488 794.338 385.585 796.697 393.222",
    fill: "#ffb8b8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M873.89764,619.17676l-6.38451,1.97208-.02494-.08076a2.60082,2.60082,0,0,1,1.71734-3.25266l.00016,0,3.89943-1.20446Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M846.56184,617.08785a.843.843,0,0,1-.56378-1.02825l1.24092-14.28517a4.31329,4.31329,0,0,1,.59931-1.84257l7.51181-12.46636,6.722,1.20785.04346.018c3.267,2.00088,6.16756,11.703,8.97265,21.08579.43622,1.45911.88724,2.9679,1.32758,4.40984a.849.849,0,0,1-.456,1.09461l-2.03534.85691a.84266.84266,0,0,1-1.06969-.37389l-10.46366-19.15639a.16794.16794,0,0,0-.13012-.08716.16313.16313,0,0,0-.1449.05612l-6.07252,6.87162-2.23162,13.09529-.009.0284a.84579.84579,0,0,1-.99941.48152l-2.1889.04144-.01366.00016Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M854.98665,588.83166l-.04255-.01353-.01284-.04276c-.03136-.10416-3.10388-10.50138-.33514-17.12967l.00285-.006c.08109-.15782,2.01243-3.86872,4.25668-4.24006l.05976-.0099.72935,1.36385c.22924.22987,4.17736,4.32928,2.38546,11.37563.16087.57776,2.34115,8.51031,1.15554,9.69589a2.17552,2.17552,0,0,1-1.47946.37125A29.87766,29.87766,0,0,1,854.98665,588.83166Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 782.29059,
    cy: 336.6688,
    r: 5.24017,
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 780.2089,
    cy: 337.73228,
    r: 4.15174,
    fill: "#ffb8b8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M858.9829,565.95626c-.3788.13432-.8432.25274-1.14128-.02583a1.00952,1.00952,0,0,1-.06656-1.13568,5.13467,5.13467,0,0,0,.51881-1.09122,1.67956,1.67956,0,0,0-.61643-1.53793,4.56035,4.56035,0,0,0-1.50382-.75671l-2.90629-1.03311a3.3578,3.3578,0,0,1-1.89718-1.22911,2.27507,2.27507,0,0,1,.9055-2.9339,3.69006,3.69006,0,0,1,3.19325-.06282,16.49424,16.49424,0,0,0,1.70217.681c1.1637.307,2.48686.03159,3.50947.68772a3.2411,3.2411,0,0,1,1.27309,2.827,8.739,8.739,0,0,1-.855,3.12622,5.81332,5.81332,0,0,1-.94785,1.66535,1.9607,1.9607,0,0,1-1.65947.71518Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 786.68557,
    cy: 334.13324,
    r: 3.38075,
    fill: "#2f2e41"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M857.20968,563.22642a.33808.33808,0,1,1,.46485.313v.74348a.12678.12678,0,1,1-.25355,0v-.74348A.33779.33779,0,0,1,857.20968,563.22642Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M846.669,575.262a1.69978,1.69978,0,0,1,1.86322,1.82263l5.53688,2.41476-2.63155,1.71117-4.85447-2.55543a1.709,1.709,0,0,1,.08592-3.39313Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ffb8b8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M856.24461,583.46967l-6.78144-2.847a.76071.76071,0,0,1-.39916-1.01365l.64-1.42147a.76179.76179,0,0,1,.91584-.41516l5.41049,1.65315.258-7.35231a2.12261,2.12261,0,0,1,2.33252-2.03761h0a2.10956,2.10956,0,0,1,1.87258,1.70358c.60125,3.07709-.86285,7.985-1.78913,10.63666a1.85316,1.85316,0,0,1-1.7432,1.23972A1.84822,1.84822,0,0,1,856.24461,583.46967Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M160.89512,581.73h-10.386V578.5771c3.28193-2.284,6.18976-2.08543,10.01505.18546Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "72.002 413.541 69.728 413.541 69.388 404.771 72.002 404.771 72.002 413.541",
    fill: "#ffb8b8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M148.68392,639.93607l-7.33148-.00027v-.09274a2.85355,2.85355,0,0,1,2.85364-2.85358h.00018l4.4778.00018Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "84.809 413.541 87.082 413.541 87.422 404.771 84.808 404.771 84.809 413.541",
    fill: "#ffb8b8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M160.33109,636.98966l4.4778-.00018h.00018a2.85355,2.85355,0,0,1,2.85363,2.85358v.09274l-7.33148.00027Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M160.97078,636.608a.83831.83831,0,0,1-.81494-.65329l-5.63559-24.5812a.27028.27028,0,0,0-.27154-.2177h-.0014a.27047.27047,0,0,0-.27082.22042l-5.17528,24.41548a.83861.83861,0,0,1-.81648.66144h-2.46531a.83461.83461,0,0,1-.83314-.88385l1.83625-30.94566.73891-.2186.01386.00018,14.514.127,3.09121,30.9116a.83417.83417,0,0,1-.76345.91283l-3.07944.24868Q161.004,636.608,160.97078,636.608Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.87472,
    cy: 347.33297,
    r: 4.55518,
    fill: "#ffb8b8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M152.18656,608.01649a7.86237,7.86237,0,0,1-2.3605-.33217,5.211,5.211,0,0,1-3.16-2.666.83556.83556,0,0,1-.06212-.62214c.50237-1.71463,2.93007-10.62722,1.38111-17.71234a7.50849,7.50849,0,0,1,1.06736-5.77057,7.41425,7.41425,0,0,1,4.80853-3.2342l0-.00019c.25692-.05016.51523-.09128.76767-.12243a7.388,7.388,0,0,1,5.98265,1.96838,7.5707,7.5707,0,0,1,2.37685,6.00167L161.79771,604.63a.82715.82715,0,0,1-.44473.6868C159.98193,606.03525,155.86333,608.01649,152.18656,608.01649Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#3f3d56"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M160.123,568.171a5.59279,5.59279,0,0,0-6.13008-3.44659l1.43624,1.16059c-1.78445.0601-3.66282-.06768-4.93693,1.18314.40562-.01126.93725.85634,1.34287.84509a2.127,2.127,0,0,0-1.781,1.22836,3.4988,3.4988,0,0,0-.20661,2.225,25.85138,25.85138,0,0,0,1.59987,3.17887c-.05289-1.812,3.5144-6.13411,5.25638-5.683a4.7797,4.7797,0,0,0-2.2071,1.67571A6.47345,6.47345,0,0,1,158.336,569.91a2.717,2.717,0,0,0,.91525.05123,1.11745,1.11745,0,0,0,.66249-1.78574Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M151.87278,606.86939a.83528.83528,0,0,1-.33421-.07055l-8.64272-3.77239a.82906.82906,0,0,1-.47353-.97867l5.72153-21.61378a3.12793,3.12793,0,0,1,3.88374-2.20764l2.28778.65293-1.61054,27.204a.83691.83691,0,0,1-.398.66207A.82833.82833,0,0,1,151.87278,606.86939Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M167.86858,602.04754l-.38025-1.43363-.55078-2.08461-.26525-.99965-.55077-2.07906-3.97453-15.017a3.12454,3.12454,0,0,0-3.8836-2.207l-2.28678.65283,1.13316,19.1343.11691,1.99745.07417,1.2593v.00185l.11863,1.98633.167,2.82461a.84023.84023,0,0,0,.83268.78636.84982.84982,0,0,0,.33389-.07048l8.64254-3.77232A.82834.82834,0,0,0,167.86858,602.04754Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "90.57 373.339 81.124 375.82 81.007 373.823 90.019 371.259 90.57 373.339",
    fill: "#ccc"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "91.386 376.423 81.317 379.068 81.198 377.081 81.198 377.079 90.835 374.338 91.386 376.423",
    fill: "#ccc"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "76.963 374.253 76.846 376.213 67.582 373.454 68.125 371.402 76.963 374.253",
    fill: "#ccc"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "76.77 377.504 67.317 374.453 66.773 376.51 76.655 379.453 76.77 377.504",
    fill: "#ccc"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M143.58366,603.74528a1.9924,1.9924,0,0,0,1.30632-2.7617l4.44408-13.95163-3.15129-.66-4.07444,13.67854a2.00318,2.00318,0,0,0,1.47533,3.69477Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ffb8b8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M149.45742,580.17315h0c.90489.09231,1.41385,1.10973,1.18887,2.37656l-1.07961,6.0792c-.08093.45571-.456.81654-.76769.73861l-3.65187-.91286c-.281-.07024-.3845-.46947-.22526-.86894l2.19232-5.49965A2.64645,2.64645,0,0,1,149.45742,580.17315Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#3f3d56"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M154.96028,562.99813h0a5.93363,5.93363,0,0,1,5.93013,5.74938h1.1175a.37094.37094,0,0,1,.37092.37093v1.48371a.37093.37093,0,0,1-.37092.37093H149.39637a.37094.37094,0,0,1-.37093-.37093V568.933A5.93482,5.93482,0,0,1,154.96028,562.99813Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M155.66945,599.68378h-2.62166a.33714.33714,0,0,1-.33676-.30544l-.52477-5.37878H156.531l-.52476,5.37872A.33715.33715,0,0,1,155.66945,599.68378Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M156.524,594.67626H152.1932a.33875.33875,0,0,1-.33834-.33835v-.812a.33875.33875,0,0,1,.33834-.33835H156.524a.33875.33875,0,0,1,.33835.33835v.812A.33875.33875,0,0,1,156.524,594.67626Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M154.41487,596.7992a1.95179,1.95179,0,0,1,.30165.0592l6.982-5.98753-.40813-2.19689,3.235-1.04927,1.10047,3.81893a1.48372,1.48372,0,0,1-.63232,1.6646l-8.84244,5.59552a1.94683,1.94683,0,1,1-1.73619-1.90456Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ffb8b8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M161.71667,580.6753v0c.96658-.27057,1.93239.46513,2.256,1.7185l1.553,6.01462c.11641.45086-.10969.93-.46284.9808l-4.13708.59507c-.31835.04579-.59883-.28069-.6105-.71061l-.16063-5.91874A2.60348,2.60348,0,0,1,161.71667,580.6753Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#3f3d56"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M208.742,596.94724h-3.14975a.40506.40506,0,0,1-.4046-.367l-.63047-6.46227h5.21989l-.63047,6.46219A.40506.40506,0,0,1,208.742,596.94724Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#e6e6e6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M209.76877,590.931h-5.20322a.407.407,0,0,1-.40651-.40651v-.9756a.407.407,0,0,1,.40651-.4065h5.20322a.407.407,0,0,1,.4065.4065v.9756A.407.407,0,0,1,209.76877,590.931Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M239.68708,634.89731a37.32421,37.32421,0,0,1-5.36456-10.01183.95872.95872,0,0,1,.45273-1.15408l7.83118-4.19612a.94625.94625,0,0,1,.83013-.0337.96243.96243,0,0,1,.54844.64263,22.80109,22.80109,0,0,0,5.0014,9.33422.96219.96219,0,0,1,.23135.81253.94625.94625,0,0,1-.48785.67251l-7.83118,4.19611A.9587.9587,0,0,1,239.68708,634.89731Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M240.22148,634.49574a.28934.28934,0,0,0,.36143.07464l7.83123-4.19621a.27759.27759,0,0,0,.14541-.19987.29366.29366,0,0,0-.0724-.25132,23.47222,23.47222,0,0,1-5.14876-9.60925.2938.2938,0,0,0-.16891-.19943.27782.27782,0,0,0-.24741.01023l-7.83107,4.1961a.28929.28929,0,0,0-.13807.3425,36.65587,36.65587,0,0,0,5.26855,9.83261Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M243.12054,625.52358l-4.26519,1.88276a.66921.66921,0,0,1-.88149-.34159l-.10549-.239a.66919.66919,0,0,1,.34159-.88148l4.26519-1.88276a.66919.66919,0,0,1,.88148.34159l.1055.239A.66921.66921,0,0,1,243.12054,625.52358Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M244.6803,628.42028l-4.26519,1.88276a.66921.66921,0,0,1-.88149-.34159l-.10549-.239a.66919.66919,0,0,1,.34159-.88148l4.26519-1.88276a.66921.66921,0,0,1,.88149.34159l.10549.239A.66921.66921,0,0,1,244.6803,628.42028Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M234.677,626.00657a2.39377,2.39377,0,0,1-.45951-3.64161l-1.79874-25.52613,5.18131.50249.14231,24.99777a2.40669,2.40669,0,0,1-3.06537,3.66748Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#a0616a"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M233.59168,605.416a.9986.9986,0,0,1-.41417-.75774l-.37965-6.87992a2.7627,2.7627,0,0,1,5.42494-.875l1.66773,6.151a1.00383,1.00383,0,0,1-.70537,1.23016l-4.744,1.28626A.99892.99892,0,0,1,233.59168,605.416Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#3f3d56"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "148.658 433.198 145.927 433.197 144.627 422.661 148.659 422.661 148.658 433.198",
    fill: "#a0616a"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M143.36536,432.41688h5.87846a0,0,0,0,1,0,0V435.734a0,0,0,0,1,0,0h-8.58554a0,0,0,0,1,0,0V435.124A2.70708,2.70708,0,0,1,143.36536,432.41688Z",
    fill: "#2f2e41"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "158.908 433.198 156.177 433.197 154.877 422.661 158.909 422.661 158.908 433.198",
    fill: "#a0616a"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M153.61523,432.41688h5.87846a0,0,0,0,1,0,0V435.734a0,0,0,0,1,0,0h-8.58554a0,0,0,0,1,0,0V435.124A2.70708,2.70708,0,0,1,153.61523,432.41688Z",
    fill: "#2f2e41"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M224.63178,652.08037l-3.00729-.14339a1.00247,1.00247,0,0,1-.955-.99444c-.79283-12.23726-1.89085-25.35887-.20988-30.428a1.00294,1.00294,0,0,1,1.14675-.99944l12.031,1.74646a.99688.99688,0,0,1,.85866.98486c1.536,6.00206,1.60546,16.886,1.54736,28.19474a1.00282,1.00282,0,0,1-1.00271,1.01032h-3.24209a.998.998,0,0,1-.99052-.8469l-2.00029-12.71593a.77988.77988,0,0,0-1.5448.0285L225.67512,651.198a1.00651,1.00651,0,0,1-.99574.88368Q224.65573,652.08168,224.63178,652.08037Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M226.74882,622.24776a15.13552,15.13552,0,0,0-5.72208-1.95993.98443.98443,0,0,1-.68039-.37275.9978.9978,0,0,1-.20748-.7579l2.88277-21.40233a7.402,7.402,0,0,1,4.31465-5.78383,7.1985,7.1985,0,0,1,6.99564.54835q.14819.09858.29082.20128a7.39286,7.39286,0,0,1,2.8157,7.70372c-1.76779,7.23174-2.375,19.0875-2.4788,21.3908a.995.995,0,0,1-.65019.89238,10.046,10.046,0,0,1-3.39266.60406A8.49509,8.49509,0,0,1,226.74882,622.24776Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 153.05778,
    cy: 359.40114,
    r: 5.47276,
    fill: "#a0616a"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M233.03293,587.922a1.76772,1.76772,0,0,1-3.05008-.982,1.79476,1.79476,0,0,1,.00226-.34664,8.0347,8.0347,0,0,0,.35783-1.95051,1.02286,1.02286,0,0,0-.1872-.47882c-.81358-1.08946-2.7234.48728-3.49124-.499-.47081-.60475.08263-1.55689-.27867-2.2328-.47685-.89209-1.88928-.452-2.775-.94057-.98549-.54357-.92655-2.0556-.27783-2.97529a4.68019,4.68019,0,0,1,3.54809-1.80634,9.51769,9.51769,0,0,1,4.0091.78243,8.012,8.012,0,0,1,3.78814,2.62654,6.41217,6.41217,0,0,1,.64823,5.45955A10.29156,10.29156,0,0,1,233.03293,587.922Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M237.367,593.24276c-.09585-.45011-.918-1.0651-2.09451-1.56646a12.9539,12.9539,0,0,0-11.69821,1.00271.55252.55252,0,0,0-.51028.43451l-3.95739,17.50275-.51474,2.27947-.34087,1.50852-.51473,2.2728-.27407,1.21438a.5588.5588,0,0,0,.49471.67961l17.08829,1.47509c.01556,0,.0334.00223.049.00223a.55711.55711,0,0,0,.5526-.52141l.16266-2.47556.17386-2.64714.07572-1.14755.17158-2.64044,1.1386-17.34456v-.01558Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M209.32805,594.34447a2.346,2.346,0,0,1,.05332.36546l9.57191,5.522,2.32659-1.33937,2.48028,3.247-4.97723,3.54746-10.92009-8.61493a2.33871,2.33871,0,1,1,1.46522-2.72766Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#a0616a"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M219.29515,599.76237a.99864.99864,0,0,1,.28815-.81405l4.87167-4.87281a2.7627,2.7627,0,0,1,4.27109,3.45738l-3.46935,5.346a1.00383,1.00383,0,0,1-1.38695.29527l-4.12319-2.67578A.99892.99892,0,0,1,219.29515,599.76237Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#3f3d56"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "160.128 386.425 159.957 389.066 142.489 388.705 143.004 386.425 160.128 386.425",
    fill: "#ccc"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "159.881 390.213 159.707 392.86 141.634 392.486 142.149 390.213 159.881 390.213",
    fill: "#ccc"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M229.26731,572.95917h0a7.12888,7.12888,0,0,0-7.12468,6.90751H220.8a.44566.44566,0,0,0-.44564.44565v1.78258a.44566.44566,0,0,0,.44564.44565h15.152a.44566.44566,0,0,0,.44565-.44565v-2.00542A7.13029,7.13029,0,0,0,229.26731,572.95917Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M269.39764,645.5h-1.52832c-.00976-.18506-2.06152-5-2.06152-5l-1.24023-3-.81983-2-1.24023-3-1.41992-3.45a.70848.70848,0,0,0-1.37989,0l-1.41992,3.45-1.24023,3-.81983,2-1.24023,3s-2.05176,4.81494-2.06153,5h-1.52832a1.5,1.5,0,0,0,0,3h18a1.5,1.5,0,0,0,0-3Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ff6584"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M268.39764,671.5h-.59228c.0542-.12793-2.57764-6.86-2.57764-6.86l-1.58008-3.85-1.06005-2.58-1.58008-3.85-1.71973-4.17a.90632.90632,0,0,0-1.76025,0l-1.71973,4.17-1.58008,3.85-1.07031,2.58-1.57959,3.85s-2.62207,6.73206-2.56787,6.86h-.61231a1.5,1.5,0,0,0,0,3h20a1.5,1.5,0,0,0,0-3Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ff6584"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "187.645 411.309 180.945 411.309 182.185 408.309 186.405 408.309 187.645 411.309",
    fill: "#f2f2f2"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "189.705 416.309 178.885 416.309 180.125 413.309 188.465 413.309 189.705 416.309",
    fill: "#f2f2f2"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "186.485 434.019 178.125 434.019 179.705 430.169 184.905 430.169 186.485 434.019",
    fill: "#f2f2f2"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "189.125 440.449 175.475 440.449 177.055 436.599 187.545 436.599 189.125 440.449",
    fill: "#f2f2f2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M489.08239,588.24605a1.4856,1.4856,0,0,0-.18822-2.27022l-.75025-4.946-3.08173.96992,1.68828,4.41266a1.49366,1.49366,0,0,0,2.33192,1.83365Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ffb8b8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M485.90768,585.91916l-1.901-8.87808a5.08388,5.08388,0,0,1,1.45184-4.75413c2.43331-2.34487,5.5607-5.30044,6.641-6.065a5.56962,5.56962,0,0,1,3.48457-1.02856l.02608.00287,1.63525,1.54539-3.56224,5.86412-5.40783,3.38832.6018,8.70167Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 407.85963,
    y: 349.66336,
    width: 9.229,
    height: 1.25139,
    rx: 0.62569,
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 407.85963,
    y: 363.27222,
    width: 9.229,
    height: 1.25139,
    rx: 0.62569,
    fill: "#ccc"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M488.6547,621.56368a.31288.31288,0,0,1-.31163-.2852l-3.98819-46.77069a.31285.31285,0,1,1,.62325-.05529l3.67206,43.21227,3.56769-43.21151a.31286.31286,0,1,1,.6234.05377l-3.87488,46.77068a.3129.3129,0,0,1-.31132.286Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 421.50518,
    cy: 335.02584,
    r: 4.10437,
    fill: "#ffb8b8"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "409.273 395.497 407.321 394.875 408.792 387.05 411.673 387.968 409.273 395.497",
    fill: "#ffb8b8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M485.2668,621.41924l-6.28372-2.00288.0519-.16322a2.476,2.476,0,0,1,3.10717-1.60517l3.92762,1.25192Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "423.475 395.456 421.426 395.456 420.451 387.554 423.475 387.554 423.475 395.456",
    fill: "#ffb8b8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M493.65544,621.47156h6.28242v-2.33131h-3.96593a2.31914,2.31914,0,0,0-2.31649,2.3165Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M499.51706,617.083l-.69145-.10319a10.45179,10.45179,0,0,1-2.55567-.47737c-.17-.0747-.182-1.20342-.0799-7.54836.07489-4.65742.16815-10.45373-.0129-13.56547a.54739.54739,0,0,0-1.04853-.18469c-1.56042,3.60355-4.17842,11.6677-5.9108,17.0039-.60259,1.85623-1.07855,3.32232-1.37967,4.20114a.70762.70762,0,0,1-.83742.4533c-1.42564-.35638-1.33032-.50792-3.36085-1.0331a.70213.70213,0,0,1-.51334-.82618c.36726-1.732,7.08825-29.8143,7.6027-32.48381a.70417.70417,0,0,1,.82985-.55871c1.51322.3049,2.43381.62836,3.9292.94114,1.61357.33751,3.2821.68656,4.90958,1.01232h0a.69812.69812,0,0,1,.4097.25113,4.35786,4.35786,0,0,0,1.63206,1.09634c.42623.20378-.53962.18542-.16841.47928,1.50321,1.19-.65847,25.35434-1.96462,30.812a.70626.70626,0,0,1-.78953.53038Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M499.35694,562.80838c-.23962-1.01677.97173-3.20458.73211-4.22135-.16228-.68858-1.78144-.2205-2.15931-.81857a2.17183,2.17183,0,0,0-1.71818-1.09053c-.81309-.00912-1.61317.594-2.3834.33334a1.53534,1.53534,0,0,1-.68339-2.07667,3.73159,3.73159,0,0,1,1.81881-1.59517A5.49069,5.49069,0,0,1,499,552.661a6.63424,6.63424,0,0,1,2.1357,1.34216,7.44265,7.44265,0,0,1,1.61728,1.64166,4.41066,4.41066,0,0,1,.06939,4.32809,6.5057,6.5057,0,0,1-3.366,2.89654",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M489.27884,586.47006c.443-.74,1.11555-4.2074,1.94494-10.02731.56467-3.973,1.05666-8.00984,1.30077-10.07191a.99153.99153,0,0,1,.5568-.78235q.23762-.11469.4724-.21707a10.82735,10.82735,0,0,1,11.5508,1.6229l.01837.01733.00474.02475c.00878.04583.85655,4.61419-.87989,7.70066-1.71256,3.04537-1.73253,11.11021-1.73253,11.19132v.10365l-.09972-.02842c-2.6642-.76126-12.95578.57055-13.05947.58415l-.16024.02092Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 420.06068,
    y: 351.69687,
    width: 9.229,
    height: 1.25139,
    rx: 0.62569,
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 420.06068,
    y: 365.30573,
    width: 9.229,
    height: 1.25139,
    rx: 0.62569,
    fill: "#ccc"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M500.85574,621.7201a.31287.31287,0,0,1-.31162-.2852l-3.9882-44.8936a.31285.31285,0,0,1,.62326-.0553l3.67206,41.33519,3.56769-41.33442a.31286.31286,0,1,1,.6234.05377l-3.87489,44.8936a.31288.31288,0,0,1-.31131.286Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M498.27991,589.695a1.48562,1.48562,0,0,1,1.39159-1.80356l3.31737-3.74446,2.06,2.48878-3.815,2.787a1.49366,1.49366,0,0,1-2.954.27223Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ffb8b8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M500.21138,587.0888l5.23348-6.978-2.69869-5.78294.19595-6.85851,2.2125-.40878.02345.01176a5.56962,5.56962,0,0,1,2.36636,2.7569c.49146,1.22878,1.51089,5.40929,2.27949,8.7a5.08388,5.08388,0,0,1-1.36447,4.77994l-6.42,6.42009Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M478.27293,619.7797l7.16,1.72387a.61357.61357,0,0,0,.71246-.33255l6.15055-16.35285a.50387.50387,0,0,0,.00054-.39824.57.57,0,0,0-.32767-.30673l-5.38325-2.05581a.64738.64738,0,0,0-.52785.02917.54923.54923,0,0,0-.28788.35226l-.00015.00076-3.79954,14.41268-.05644.00351a5.21824,5.21824,0,0,0-3.17949,1.32532A2.07914,2.07914,0,0,0,478.27293,619.7797Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 486.54934,
    y: 607.83171,
    width: 0.3129,
    height: 6.56433,
    transform: "translate(-248.36824 806.56434) rotate(-83.95484)",
    fill: "#b3b3b3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 485.29517,
    y: 611.63431,
    width: 0.31291,
    height: 5.76036,
    transform: "translate(-350.24068 580.8869) rotate(-65.77563)",
    fill: "#b3b3b3"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "414.571 384.922 408.379 382.871 408.508 382.586 414.699 384.636 414.571 384.922",
    fill: "#b3b3b3"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "415.197 383.514 409.005 380.525 409.133 380.239 415.325 383.228 415.197 383.514",
    fill: "#b3b3b3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 484.3173,
    y: 614.72962,
    width: 0.3128,
    height: 5.8713,
    transform: "translate(-375.9425 360.65748) rotate(-49.49475)",
    fill: "#b3b3b3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 481.67309,
    y: 616.7747,
    width: 0.31283,
    height: 4.3402,
    transform: "translate(-288.71359 30.05603) rotate(-24.39334)",
    fill: "#b3b3b3"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M655.57387,589.55583a1.86312,1.86312,0,0,1-1.29111-2.54844l-6.86818-15.517,3.92895-.98958,5.51577,15.56392a1.87319,1.87319,0,0,1-1.28543,3.49114Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#a0616a"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M648.68922,576.3524a.83448.83448,0,0,1-.45877-.52287l-1.20085-4.01712a2.32,2.32,0,0,1,4.19664-1.97941l2.3223,3.5072a.83539.83539,0,0,1-.3424,1.21775l-3.82124,1.78867A.83443.83443,0,0,1,648.68922,576.3524Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M662.67067,574.35105l-4.21288,2.98267a.31621.31621,0,0,1-.37131,0l-1.13839-.85481a.31212.31212,0,0,1-.0204-.4876l3.24177-2.89086a.32029.32029,0,0,1,.31622-.0612l2.1095.75484a.31826.31826,0,0,1,.07549.557Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#3f3d56"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M662.32759,574.06846a.11338.11338,0,0,0-.06545-.14514l-1.9001-.67983a.11384.11384,0,0,0-.11246.02083l-2.924,2.60753-.016.01728a.10875.10875,0,0,0,.02507.15226l1.02385.76874a.11156.11156,0,0,0,.13261-.00119l3.79659-2.688A.11238.11238,0,0,0,662.32759,574.06846Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#fff"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "571.214 394.628 573.34 394.628 574.352 386.427 571.214 386.427 571.214 394.628",
    fill: "#a0616a"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M646.774,618.12489l4.18723-.00017h.00017a2.6684,2.6684,0,0,1,2.66846,2.66842v.08671l-6.85574.00026Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "564.103 394.628 566.23 394.628 567.241 386.427 564.103 386.427 564.103 394.628",
    fill: "#a0616a"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M639.6634,618.12489l4.18724-.00017h.00016a2.66838,2.66838,0,0,1,2.66846,2.66842v.08671l-6.85573.00026Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M639.75465,616.3128a.93422.93422,0,0,1-.23054-.60142c-.50674-5.21437.87239-32.6254,4.05907-34.96607l.01972-.01914,9.32664-1.6104h0l.17343.17343c.01346.24168,1.70917,24.26861-2.97345,36.53109a.78045.78045,0,0,1-.72708.49606h-1.86195a.78039.78039,0,0,1-.778-.84157l1.50747-22.9607a.26014.26014,0,0,0-.51352-.07587l-4.24553,23.304a.78516.78516,0,0,1-.7049.61225l-2.44515.18105q-.029.002-.05784.002A.78124.78124,0,0,1,639.75465,616.3128Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 575.92466,
    cy: 336.60961,
    r: 4.25959,
    fill: "#a0616a"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M641.76742,584.4756a1.00946,1.00946,0,0,1-.28936-.68481l1.73946-8.1436c-1.38743-5.89658.45974-7.002,2.54444-8.11942l-.01334-.00691.87062-2.35621a.73624.73624,0,0,1,1.02969-.47665l4.43971,2.35886a.87838.87838,0,0,1,.412.51848,1.10124,1.10124,0,0,1-.01457.71608l-.32784.88729c.84775,1.13241,2.15876,5.61134.77133,7.34563l1.047,5.77968a.91242.91242,0,0,1-.65.97258l-10.93957,1.40376a.64689.64689,0,0,1-.1291.013A.7062.7062,0,0,1,641.76742,584.4756Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M657.69309,575.13613a1.8255,1.8255,0,0,0-.19322.21283l-8.58044-.59291-.9205-1.87579-3.01247,1.01919,1.30685,3.47908a1.38742,1.38742,0,0,0,1.40374.89558l9.75711-.73994a1.8205,1.8205,0,1,0,.23893-2.398Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#a0616a"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M648.59915,574.78591l-3.7398,1.24506a.78045.78045,0,0,1-1.01511-.60509l-.68149-3.87012a2.16741,2.16741,0,0,1,4.11686-1.35721l1.76939,3.49456a.78043.78043,0,0,1-.44985,1.0928Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#6c63ff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 573.53203,
    cy: 329.77749,
    r: 3.46858,
    fill: "#2f2e41"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M656.05938,561.32729a1.81518,1.81518,0,0,0,1.00408-.08414,1.19242,1.19242,0,0,0,.59611-.89948c.64626-4.29395-3.005-3.94074-3.43688-4.12671a4.7327,4.7327,0,0,1-.76364-.55724,3.57027,3.57027,0,0,0-1.99491-.43875,5.7521,5.7521,0,0,0-2.4241.29638,3.631,3.631,0,0,0-1.61129,1.48519,7.49859,7.49859,0,0,0-.79895,2.06956,5.16471,5.16471,0,0,0-.13588,2.537,3.13733,3.13733,0,0,0,2.84755,2.282A2.34714,2.34714,0,0,1,650.5803,561.32a3.57989,3.57989,0,0,1,2.36152-.28119,10.39628,10.39628,0,0,0,1.56644.19507C655.02471,561.2532,655.6448,561.28348,656.05938,561.32729Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#2f2e41"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M989.42222,619.66535a17.16536,17.16536,0,0,1,34.33071,0",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.58758,619.66535a.464.464,0,0,1-.46393-.46392v-9.04661a.46393.46393,0,0,1,.92786,0v9.04661A.464.464,0,0,1,1006.58758,619.66535Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M1006.58735,616.55672a.4618.4618,0,0,1-.302-.11191l-5.56709-4.77814a.46392.46392,0,1,1,.60432-.704l5.56715,4.77814a.46394.46394,0,0,1-.30242.816Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M1042.31007,619.66535a17.16536,17.16536,0,0,1,34.33071,0",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#f2f2f2"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.47543,619.66535a.46394.46394,0,0,1-.46393-.46392v-9.04661a.46393.46393,0,0,1,.92786,0v9.04661A.464.464,0,0,1,1059.47543,619.66535Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M1059.4752,616.55672a.4618.4618,0,0,1-.302-.11191l-5.56714-4.77814a.46394.46394,0,1,1,.60437-.704l5.56714,4.77814a.46393.46393,0,0,1-.30241.816Z",
    transform: "translate(-76.10236 -224.19109)",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWellcome);
export default __webpack_public_path__ + "static/media/wellcome.d3027b13fa3e64281bf3604fb8cd7868.svg";
export { ForwardRef as ReactComponent };